// 딜러잭 게임 룰 및 설정 다국어 지원

// 기본 규칙 배열 (이모티콘 제거)
export const dealerjack_rules_ko = [
  "목표: 딜러보다 21에 가까운 수를 만들되, 21을 넘으면 안 됩니다.",
  "카드 값: A는 1 또는 11, J/Q/K는 10, 나머지는 숫자 그대로입니다.",
  "각 라운드마다 칩을 걸고 시작합니다.",
  "카드를 한 장 더 받습니다.",
  "더 이상 카드를 받지 않고 현재 점수로 승부합니다.",
  "블랙잭: 처음 2장으로 21을 만들면 1.5배 배당을 받습니다.",
  "버스트: 21을 넘으면 자동으로 패배합니다.",
  "딜러 규칙: 딜러는 16 이하에서는 반드시 카드를 받고, 17 이상에서는 스탠드합니다.",
];

export const dealerjack_rules_en = [
  "Objective: Get closer to 21 than the dealer without going over.",
  "Card Values: A = 1 or 11, J/Q/K = 10, others = face value.",
  "Place chips at the start of each round.",
  "Draw one more card.",
  "Choose to stop receiving more cards and keep your current total.",
  "Blackjack: Getting 21 with first 2 cards pays 1.5x.",
  "Bust: Going over 21 results in automatic loss.",
  "Dealer Rules: Dealer must hit on 16 or less, stand on 17 or more.",
];

// 상세 규칙 및 설정 번역
export const dealerjack_translations_ko = {
  // Game overview
  gameOverview: "게임 개요",
  gameOverviewDescription:
    "블랙잭은 21에 가까운 수를 만들되 21을 넘지 않으면서 딜러를 이기는 것이 목표인 클래식 카드 게임입니다.",

  // Basic rules
  basicRules: "기본 규칙",
  objective: "목표",
  objectiveDescription: "21을 넘지 않으면서 딜러보다 21에 가까운 수 만들기.",
  cardValues: "카드 값",

  // Game flow
  gameFlow: "게임 진행",
  step1: "베팅 단계",
  step1Description: "각 플레이어가 칩으로 베팅을 합니다.",
  step2: "초기 카드 배분",
  step2Description: "모든 플레이어가 2장씩, 딜러는 1장만 공개됩니다.",
  step3: "플레이어 턴",
  step3Description:
    "플레이어들이 Hit(카드 받기) 또는 Stand(멈추기)를 선택합니다.",
  step4: "딜러 턴",
  step4Description:
    "딜러가 숨겨진 카드를 공개하고 하우스 룰에 따라 진행합니다.",
  step5: "결과 판정",
  step5Description: "핸드를 비교하여 승부를 결정합니다.",

  // Player actions
  playerActions: "플레이어 액션",
  hit: "히트",
  hitDescription: "카드를 한 장 더 받아 핸드 값을 높입니다.",
  stand: "스탠드",
  standDescription: "현재 핸드를 유지하고 턴을 끝냅니다.",
  doubleDown: "더블다운",
  doubleDownDescription:
    "베팅을 2배로 늘리고 카드 1장만 받은 후 자동으로 스탠드합니다.",
  surrender: "서렌더",
  surrenderDescription: "라운드를 포기하고 베팅액의 50%를 돌려받습니다.",

  // Additional game terms
  or: "또는",
  autoCalculated: "자동 계산",
  bust: "버스트",
  bustDescription: "21을 넘으면 자동으로 패배합니다.",
  normalWin: "일반 승리",
  normalWinPayout: "베팅액의 1배를 보상으로 받습니다.",
  pushShort: "푸시",
  loseDescription: "베팅한 칩을 모두 잃습니다.",
  dealerRule4: "딜러는 소프트 17(A가 포함된 17)에서도 스탠드합니다.",

  // Win conditions
  winConditions: "승리 조건",
  blackjack: "블랙잭",
  blackjackDescription: "처음 2장으로 21 만들기 (A + 10/J/Q/K).",
  blackjackPayout: "베팅액의 1.5배를 보상으로 받습니다.",
  win: "승리",
  winDescription: "버스트 없이 딜러를 이기기.",
  winPayout: "1:1 배당",
  push: "무승부",
  pushDescription: "딜러와 동점.",
  pushPayout: "베팅한 칩만 그대로 반환됩니다.",

  // Dealer rules
  dealerRules: "딜러 규칙",
  dealerRule1: "딜러는 16 이하에서 반드시 히트.",
  dealerRule2: "딜러는 17 이상에서 반드시 스탠드.",
  dealerRule3: "딜러는 모든 플레이어 다음에 행동.",

  // Strategy tips
  tips: "전략 팁",
  tip1: "17 이상에서는 스탠드하세요.",
  tip2: "딜러가 7 이상 보이고 내가 16 이하면 히트하세요.",
  tip3: "딜러가 2-10일 때 11에서 더블다운하세요.",
  tip4: "인슈어런스는 절대 하지 마세요.",
  tip5: "자금을 현명하게 관리하세요.",
  tip6: "기본 전략을 익혀 승률을 높이세요.",

  // Game settings
  gameMode: "게임 모드",
  dealerMode: "딜러 모드",
  battleMode: "대결 모드",
  dealerModeDescription: "기본 블랙잭 - 딜러와 대전.",
  battleModeDescription: "플레이어 대 플레이어 - 다른 플레이어들과만 대전.",
  gameSettings: "게임 설정",
  botCount: "AI 플레이어",
  aiPlayers: "AI 플레이어",
  bettingSettings: "베팅 설정",
  startingChips: "시작 칩",
  minBet: "최소 베팅",
  maxBet: "최대 베팅",
  bettingDescription: "베팅 한도와 시작 자금을 설정하세요.",
  timeSettings: "시간 설정",
  bettingTime: "베팅 시간",
  turnTime: "턴 시간",
  quickRules: "간단 규칙",
  rule1: "21에 최대한 가깝게 만드세요.",
  rule2: "버스트 없이 딜러를 이기세요.",
  rule3: "A는 1 또는 11로 계산됩니다.",
  rule4: "그림 카드는 모두 10입니다.",

  // Quick rule descriptions for settings
  quickRuleDesc1: "목표: 딜러보다 21에 가까이.",
  quickRuleDesc2: "A=1/11, 그림카드=10, 나머지=숫자.",
  quickRuleDesc3: "히트로 카드 받기, 스탠드로 멈추기.",
  quickRuleDesc4: "블랙잭(A+10)은 1.5배 배당.",

  // Game UI and actions
  playerActionCompleted: "님이 액션을 완료했습니다.",
  remainingPlayers: "남은 플레이어",
  players: "명",
  waiting: "대기",
  betting: "베팅",
  dealing: "카드 배분",
  action: "액션",
  dealerTurn: "딜러 턴",
  resultsCheck: "결과 확인",
  minimumBet: "최소 베팅",
  chips: "칩",
  cancel: "취소",
  skip: "스킵",
  doubleDownTitle: "더블다운",
  doubleDownExplanation:
    "베팅을 2배로 늘리고 카드 1장을 받은 후 자동으로 스탠드합니다.",
  currentBet: "현재 베팅",
  additionalBet: "추가 베팅",
  totalBet: "총 베팅",
  surrenderTitle: "항복",
  surrenderExplanation: "게임을 포기하고 베팅액의 50%를 돌려받습니다.",
  loss: "손실",
  return: "반환",
  playerResults: "플레이어 결과",
  ownChips: "보유 칩",
  betAmount: "베팅",
  surrendered: "항복",
  blackjackWin: "BlackJack!",
  victory: "승리",
  draw: "무승부",
  defeat: "패배",
  me: "나",
  firstActionOnly: "첫 번째 액션으로만 가능",
  finalChips: "최종 칩",
};

export const dealerjack_translations_en = {
  // Game overview
  gameOverview: "Game Overview",
  gameOverviewDescription:
    "Blackjack is a classic card game where the goal is to get as close to 21 as possible without going over, while beating the dealer's hand.",

  // Basic rules
  basicRules: "Basic Rules",
  objective: "Objective",
  objectiveDescription:
    "Get closer to 21 than the dealer without exceeding 21.",
  cardValues: "Card Values",

  // Game flow
  gameFlow: "Game Flow",
  step1: "Betting Phase",
  step1Description: "Each player places their bet using chips.",
  step2: "Initial Deal",
  step2Description: "Everyone gets 2 cards, dealer shows 1 card.",
  step3: "Player Turns",
  step3Description: "Players choose to Hit (take card) or Stand (stop).",
  step4: "Dealer Turn",
  step4Description: "Dealer reveals hidden card and follows house rules.",
  step5: "Results",
  step5Description: "Compare hands and determine winners.",

  // Player actions
  playerActions: "Player Actions",
  hit: "Hit",
  hitDescription: "Take another card to increase your hand value.",
  stand: "Stand",
  standDescription: "Keep your current hand and end your turn.",
  doubleDown: "Double Down",
  doubleDownDescription:
    "Double your bet and receive exactly one more card, then stand automatically.",
  surrender: "Surrender",
  surrenderDescription: "Give up the hand and lose half of your bet.",

  // Additional game terms
  or: "or",
  autoCalculated: "auto calculated",
  bust: "Bust",
  bustDescription: "Going over 21 results in automatic loss.",
  normalWin: "Normal Win",
  normalWinPayout: "Pays 1x your bet.",
  pushShort: "Push",
  loseDescription: "You lose your entire bet.",
  dealerRule4: "Dealer stands on soft 17 (A included in 17).",

  // Win conditions
  winConditions: "Win Conditions",
  blackjack: "Blackjack",
  blackjackDescription: "21 with first 2 cards (A + 10/J/Q/K).",
  blackjackPayout: "Pays 1.5x your bet.",
  win: "Win",
  winDescription: "Beat dealer without busting.",
  winPayout: "Pays 1:1.",
  push: "Push",
  pushDescription: "Tie with dealer.",
  pushPayout: "Your bet is returned.",

  // Dealer rules
  dealerRules: "Dealer Rules",
  dealerRule1: "Dealer must hit on 16 or less.",
  dealerRule2: "Dealer must stand on 17 or more.",
  dealerRule3: "Dealer acts last after all players.",

  // Strategy tips
  tips: "Strategy Tips",
  tip1: "Stand on 17 or higher.",
  tip2: "Hit when dealer shows 7+ and you have 16 or less.",
  tip3: "Double down on 11 against dealer's 2-10.",
  tip4: "Never take insurance.",
  tip5: "Manage your bankroll wisely.",
  tip6: "Learn basic strategy for better odds.",

  // Game settings
  gameMode: "Game Mode",
  dealerMode: "Dealer Mode",
  battleMode: "Battle Mode",
  dealerModeDescription: "Classic blackjack - compete against the dealer.",
  battleModeDescription:
    "Player vs Player - compete against other players only.",
  gameSettings: "Game Settings",
  botCount: "AI Players",
  aiPlayers: "AI Players",
  bettingSettings: "Betting Settings",
  startingChips: "Starting Chips",
  minBet: "Minimum Bet",
  maxBet: "Maximum Bet",
  bettingDescription: "Set betting limits and starting money.",
  timeSettings: "Time Settings",
  bettingTime: "Betting Time",
  turnTime: "Turn Time",
  quickRules: "Quick Rules",
  rule1: "Get as close to 21 as possible.",
  rule2: "Beat the dealer without busting.",
  rule3: "Aces count as 1 or 11.",
  rule4: "Face cards are worth 10.",

  // Quick rule descriptions for settings
  quickRuleDesc1: "Goal: Get closer to 21 than dealer.",
  quickRuleDesc2: "A=1/11, Face cards=10, Others=face value.",
  quickRuleDesc3: "Hit to take card, Stand to stop.",
  quickRuleDesc4: "Blackjack (A+10) pays 1.5x.",

  // Game UI and actions
  playerActionCompleted: " completed their action.",
  remainingPlayers: "Remaining players",
  players: "",
  waiting: "Waiting",
  betting: "Betting",
  dealing: "Dealing",
  action: "Action",
  dealerTurn: "Dealer Turn",
  resultsCheck: "Results",
  minimumBet: "Minimum bet",
  chips: "chips",
  cancel: "Cancel",
  skip: "Skip",
  doubleDownTitle: "Double Down",
  doubleDownExplanation:
    "Double your bet and receive exactly one more card, then stand automatically.",
  currentBet: "Current bet",
  additionalBet: "Additional bet",
  totalBet: "Total bet",
  surrenderTitle: "Surrender",
  surrenderExplanation: "Give up the game and get 50% of your bet back.",
  loss: "Loss",
  return: "Return",
  playerResults: "Player Results",
  ownChips: "Own Chips",
  betAmount: "Bet",
  surrendered: "Surrendered",
  blackjackWin: "BlackJack!",
  victory: "Win",
  draw: "Push",
  defeat: "Loss",
  me: "Me",
  firstActionOnly: "First action only",
  finalChips: "Final Chips",
};
